import { ReactElement } from 'react';

import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { StepIconProps, styled } from '@mui/material';

const StepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: '#889297',
  zIndex: 1,
  color: '#fff',
  width: 34,
  height: 34,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: 24,
  ...(ownerState.active && {
    backgroundColor: theme.palette.horizonWhite.main,
  }),
  ...(ownerState.completed && {
    backgroundColor: theme.palette.horizonGreen.main,
  }),
}));

export const StepIcon = (props: StepIconProps): ReactElement => {
  const { active, completed, className } = props;

  return (
    <StepIconRoot ownerState={{ completed, active }} className={className}>
      {
        <CheckRoundedIcon
          sx={{
            color: ({ palette }) => palette.horizonBlue2.main,
            fontSize: 24,
          }}
        />
      }
    </StepIconRoot>
  );
};
